import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AttachmentDto } from '../../models/attachment/attachment-dto.model';
import { OfflineUploadResult, UploadResult } from './attachment-transfer.service';
import { CreateMetadata } from './attachment.service';

export const ATTACHMENT_LOCAL_PREFIX = 'local|';
export const ATTACHMENT_PAGINATION_DEFAULT = 5;

export const AttachmentServiceToken = new InjectionToken('AttachmentServiceToken');
export interface IAttachmentService {
  init(): Promise<void>;
  save(attachments: AttachmentDto[]): Promise<void>;
  get<T extends 'blobUrl' | 'blob' | 'base64'>(id: string, returnValue: T): Promise<T extends 'blob' ? Blob : string>;
  create(base64String: string, metadata: CreateMetadata): Promise<UploadResult>;
  update(attachment: AttachmentDto): Promise<boolean>;
  delete(id: string): Promise<void>;
  runAttachmentQueuesProcessor(): Promise<void>;
  download(id: string, mimeType: string): Promise<Blob>;
  upload(localId: string): Promise<UploadResult | null>;
  get offlineTxSuccess(): Observable<OfflineUploadResult>;
  getLocalAttachments(): Promise<string[]>;
  softDelete(attachment: AttachmentDto): Promise<boolean>;
  getAttachmentDto(id: string): Promise<AttachmentDto>;
  isAttachmentBlobLocallyAvailable(id: string): Promise<boolean>;
}
